<div class="lum-modal lum-c-order-shipments-details">
  <div class="lum-modal__header flex justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">Shipment Details</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>

  <mat-dialog-content>
    <ng-container
      *ngIf="loading$ | async; then loader; else shipmentDetails"
    ></ng-container>
  </mat-dialog-content>
</div>

<ng-template #loader>
  <div
    class="d-flex justify-content-center align-items-center"
    style="min-height: 300px"
  >
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
</ng-template>

<ng-template #shipmentDetails>
  <ng-container *ngIf="shipment$ | async as shipment">
    <div class="p-5">
      <!-- Details -->
      <h5 class="text-lg font-bold mb-2">Details</h5>
      <hr class="my-3" />
      <div class="row">
        <div class="form-group col-md-6">
          <label class="lum-label">Fulfillment Order ID</label>
          <div class="text-medium">{{ shipment?.salesOrderShipmentId || '-' }}</div>
        </div>
        <div class="form-group col-md-6">
          <label class="lum-label">Warehouse Group</label>
          <div class="text-medium">{{
            shipment?.fulfillmentOrderWarehouseGroup ||
              shipment?.salesOrderWarehouseGroup ||
              '-'
          }}</div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label class="lum-label">Shipment ID</label>
          <div class="text-medium">{{ shipment?.shipmentId || '-' }}</div>
        </div>
        <div class="form-group col-md-3">
          <label class="lum-label">Carrier</label>
          <div class="text-medium">{{ shipment?.carrierCode || '-' }}</div>
        </div>
        <div class="form-group col-md-3">
          <label class="lum-label">Tracking Number</label>
          <div class="text-medium">{{ shipment?.trackingNumber || '-' }}</div>
        </div>
        <div class="form-group col-md-3">
          <label class="lum-label">SSCC</label>
          <div class="text-medium">{{ shipment?.sscc || '-' }}</div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label class="lum-label">Ship Date</label>
          <div class="text-medium">{{
            shipment?.shipDate | date: 'mediumDate'
          }}</div>
        </div>
        <div class="form-group col-md-3">
          <label class="lum-label">Cost</label>
          <div class="text-medium">{{ shipment?.shipmentCost | lumCurrency }}</div>
        </div>
        <div class="form-group col-md-3">
          <label class="lum-label">Status</label>
          <div class="text-medium">{{ shipment?.lumStatus || '-' }}</div>
        </div>
        <div class="form-group col-md-3">
          <label class="lum-label">Source</label>
          <div class="text-medium">{{
            shipment?.appIntegrationAccountId ? 'OMS' : 'Manual'
          }}</div>
        </div>
      </div>

      <!-- Weight & Dimensions -->
      <h5 class="text-lg font-bold mt-5 mb-2">Weight & Dimensions</h5>
      <hr class="my-3" />
      <div class="row">
        <div class="form-group col-md-3">
          <label class="lum-label">Weight</label>
          <div class="text-medium">
            {{ shipment?.weight?.value || 0 }}
            {{ shipment?.weight?.units | unitAbbreviation }}
          </div>
        </div>
        <div class="form-group col-md-9">
          <label class="lum-label">Size (L x W x H)</label>
          <div class="text-medium">
            {{ shipment?.dimensions?.length || 0 }} x
            {{ shipment?.dimensions?.width || 0 }} x
            {{ shipment?.dimensions?.height || 0 }}
            {{ shipment?.dimensions?.units | unitAbbreviation }}
          </div>
        </div>
      </div>

      <!-- Line Items -->
      <h5 class="text-lg font-bold mt-5 mb-2">Line Items</h5>
      <hr class="my-3" />
      <div>
        <table class="w-100 lum-table--striped">
          <thead>
            <tr>
              <th class="p-2">Item SKU</th>
              <th class="p-2">Item Name</th>
              <th class="p-2 text-center">Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of shipment?.shipmentItems; trackBy: trackById">
              <td class="p-2">{{ item?.sku }}</td>
              <td class="p-2">{{ item?.name }}</td>
              <td class="p-2 text-center">{{ item?.quantity }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</ng-template>
